"use client";

import React, { createContext, useContext, useMemo } from "react";
import { useBackOverrideRef } from "@/utils/hooks/useBackOverrideRef";

interface CheckoutNavigationContextType {
  setCheckoutBackOverride: (overrideFn: () => boolean) => void;
  clearCheckoutBackOverride: () => void;
  handleCheckoutBackPress: () => boolean;
}

const defaultContextValue: CheckoutNavigationContextType = {
  setCheckoutBackOverride: () => {},
  clearCheckoutBackOverride: () => {},
  handleCheckoutBackPress: () => false,
};

const CheckoutNavigationContext =
  createContext<CheckoutNavigationContextType>(defaultContextValue);

export const CheckoutNavigationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    setOverride: setCheckoutBackOverride,
    clearOverride: clearCheckoutBackOverride,
    invokeOverride: handleCheckoutBackPress,
  } = useBackOverrideRef();

  const contextValue = useMemo(
    () => ({
      setCheckoutBackOverride,
      clearCheckoutBackOverride,
      handleCheckoutBackPress,
    }),
    [setCheckoutBackOverride, clearCheckoutBackOverride, handleCheckoutBackPress]
  );

  return (
    <CheckoutNavigationContext.Provider value={contextValue}>
      {children}
    </CheckoutNavigationContext.Provider>
  );
};

export const useCheckoutNavigation = () => useContext(CheckoutNavigationContext);

